import script from "./ModalMain.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalMain.vue?vue&type=script&setup=true&lang=ts"

import "./ModalMain.vue?vue&type=style&index=0&id=5588288e&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5588288e"]])

export default __exports__